<template>
  <div style="
      display: block;
      margin: 0px;
      padding: 0px;
      min-height: calc(100vh - 150px);
      margin-bottom: 55px;
    " class="mt-4 container d-flex">
    <div class="row p-0 m-0" style="max-width: 590px; padding: 0px !important;">
      <!-- ********************FULL SCREEN MESSAGES********************************************** -->
      <div v-if="showFiveSecCountDown" id="fiveSecCountDown" class="fullScreenMessages" style="
          font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI',
            Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue',
            sans-serif;
        "></div>

      <audio v-if="soundCountDown" id="audio" controls autoplay style="display: none">
        <source src="../../static/sounds/5sec.mp3" type="audio/mp3" />
      </audio>
      <!-- ******************** END OF FULL SCREEN MESSAGES********************************************** -->
      <div class="sentenceAboveMap " id="sentenceAboveMap" :style="variableBackgroundColor" v-if="!showVideo">
        <div style="font-family: 'VarelaRound'">
          {{ lang }}{{ sentenceShownAboveMap }}
        </div>
      </div>

      <!-- ******************** MAP AND VIDEO ********************************************** -->

      <div style="
          min-height: 320px;
          max-width: 590px;
          position: relative;
          overflow: hidden;
          padding: 0px;
        ">
        <div id="map2" :style="variableBackgroundColor">
          <!-- <map /> -->
          <!-- <GMapMap v-if="showMap" :center="centerMap" :zoom="Number(mapParameters.zoom)" map-type-id="satellite" -->
          <GMapMap ref="gmap" v-if="showMap" @load="saveMap" :center="centerMap" :zoom="Number(mapParameters.zoom)"
            map-type-id="satellite" :tilt="0" style="width: 100vw; height: 50vh" :styles="myMapStyle" :options="{
              zoomControl: false,
              mapTypeControl: true,
              scaleControl: false,
              streetViewControl: false,
              rotateControl: true,
              fullscreenControl: false,
              disableDefaultUi: false,
            }">
            <GMapPolyline v-if="noGoogleRouteArray[pointNum]" :path="wayPoints[pointNum]" :editable="false" :options="{
              strokeColor: '#5C81C4',
              strokeWeight: 5,
              strokeOpacity: 0.8,
            }" />
            <!-- <DirectionsRenderer v-else-if="startLocation && endLocation && !noGoogleRouteArray[pointNum]"
              :travelMode="'WALKING'" :origin="startLocation" :destination="endLocation"
              :waypoints="wayPoints[pointNum]" :icon="iconImage" @directions_changed="logDirections" /> -->
            <DirectionsRenderer v-else-if="mapObject && startLocation && endLocation" :map="mapObject"
              :key="'route-' + pointNum" :travelMode="'WALKING'" :origin="startLocation" :destination="endLocation"
              :waypoints="wayPoints[pointNum]" :icon="iconImage" @directions_changed="logDirections" />
            <GMapMarker v-if="showPosMarker" :clickable="true" @click="centerMap = m.position"
              :position="myCurrentPosition" :icon="iconImage" />
            <GMapMarker style="margin-right: 10px !important" :key="index" v-for="(m, index) in twoMarkersArray"
              :position="m" :clickable="true" :draggable="false" :label="{
                text: `${index + 1}`,
                color: 'white',
                fontSize: '9px',
              }" @click="centerMap = m" />
          </GMapMap>
        </div>
        <div class="text-center col-6 precisePosition mt-4" @click="showOpenWazeAlert = true">
          {{ translation.getPrecisePosition }}
          <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px  " fill="currentColor"
            class="bi bi-crosshair" viewBox="0 0 16 16">
            <path
              d="M8.5.5a.5.5 0 0 0-1 0v.518A7 7 0 0 0 1.018 7.5H.5a.5.5 0 0 0 0 1h.518A7 7 0 0 0 7.5 14.982v.518a.5.5 0 0 0 1 0v-.518A7 7 0 0 0 14.982 8.5h.518a.5.5 0 0 0 0-1h-.518A7 7 0 0 0 8.5 1.018zm-6.48 7A6 6 0 0 1 7.5 2.02v.48a.5.5 0 0 0 1 0v-.48a6 6 0 0 1 5.48 5.48h-.48a.5.5 0 0 0 0 1h.48a6 6 0 0 1-5.48 5.48v-.48a.5.5 0 0 0-1 0v.48A6 6 0 0 1 2.02 8.5h.48a.5.5 0 0 0 0-1zM8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4" />
          </svg>
        </div>
        <!-- <div v-else id="videoDiv">
         
          <YouTube
            v-if="withVideo"
            :video-id="videoId"
            :player-vars="playerVars"
            @playing="playing"
            style="position: relative; width: 100vw"
          ></YouTube>
          <div v-else class="pointInfoDiv">
            {{ translation.didYouKnow }}

            <br />
            <br />
            {{ points[pointNum + 1].pointInformation }}
          </div>
        </div> -->
        <!-- J'ESSAZE DE METTRE LES FULLSCREENMESSAGE SUR LA CARTE -->
        <div>
          <div v-if="showMessageTimeFinished" id="timeFinishedElement" class="messageOverMap p-3"
            style="font-size: 30px">
            {{ translation.timeOver }}
          </div>
          <div v-if="showOpenWazeAlert" class="messageOverMap p-3" style="font-size: 30px">
            {{ translation.showOpenWazeAlert }}
            <div class="row p-0 mt-5">
              <div class="col-6" @click="showOpenWazeAlert = false">
                {{ translation.back }}
              </div>
              <div class="col-6 allowButton" @click="openWaze">
                {{ translation.allow }}
              </div>
            </div>
          </div>
          <div v-if="showVerifyingPosition" id="verifyingPosition" class="messageOverMap p-3" style="font-size: 30px">
            {{ translation.locationVerification }}
            <img src="../../static/img/satellite.gif" alt="" />
          </div>
          <div v-if="showBuzzer" id="buzzer" class="messageOverMap">
            <button id="buttonBuzzer" class="buzzerButton btn btn-primary btn-lg font-weight-bold mb-4"
              style="z-index: 20" @click="buzzerClicked"></button>
          </div>
        </div>
      </div>
      <!-- ******************** END OF MAP AND VIDEO ********************************************** -->

      <!-- <div v-if="showtextEncouragement" class="textEncouragement">
          <span class="appearSlowly">{{ textEncouragement }}</span>
        </div> -->

      <!-- Timer is shown in play.vue bottom-bar center circle via countdownTimer watcher -->
    </div>
  </div>
</template>


<script>
// import { gmapApi } from "vue2-google-maps";
// import map from "./map";
import DirectionsRenderer from '@/components/DirectionsRenderer.vue'
// import DirectionsRenderer from "../DirectionsRenderer";
// import PolylineMap from "../polyline";

export default {
  // components: { DirectionsRenderer, PolylineMap },
  components: { DirectionsRenderer }, props: {
    points: Object,
    //currentPointData: Object,
    //pointNum: Number,
    // ...
  },

  // computed: {
  //   google: gmapApi,
  // },
  data() {
    return {
      currentPointData: null,
      mapObject: null,
      timerDisplayText: "00:00", // Nouvelle variable
      showOpenWazeAlert: false,
      showTimerBackground: true,
      // lang: this.$parent.language,
      mapParameters: this.$parent.mapParameters,
      sentenceShownAboveMap: "",
      sentenceAboveMap: "",
      wongAnswerSound: require("../../static/sounds/wrongAnswer.mp3"),
      buzzerFlip: require("../../static/sounds/correctAnwer.mp3"),
      typingSound: require("../../static/sounds/typing.mp3"),
      buzzerClickSound: require("../../static/sounds/buzzerClicked.mp3"),
      pointsScoreCoins: require("../../static/sounds/coins.mp3"),
      correctAnswerSound: require("../../static/sounds/correctAnswer.mp3"),
      countDown: "",
      countDounTimeInSeconds: "",
      timeFinishedLoop: "",
      showMessageTimeFinished: false,
      showBuzzer: false,
      showVerifyingPosition: false,
      showFiveSecCountDown: false,
      soundCountDown: false,
      startTimeCountDown: null,
      showVideo: false,
      //showExplosion: false,
      pointsScore: 0,
      min: "",
      sec: 0,
      showTimmer: true,
      playerVars: {
        autoplay: 1,
      },
      showMap: true,
      noGoogleRouteArray: [],
      gettingClosed: false,
      showtextEncouragement: true,
      textEncouragement: "",
      textEncouragementArray: [
        "אתם בדרך הנכונה",
        "הכפתור יופיע כשתגיעו למקום",
        "תמשיכו ללכת לפי המסלול",
      ],
      textEncouragementArrayClose: [
        "אתם קרובים !",
        "עוד מעט מגיעים",
        "מעולים אתם !",
        "עוד מעט תראו את הכפתור",
        "יופי של קצב",
      ],
      buttonNameNotThere: "",
      reachedThePoint: false,
      rangeInPosition: 0.0004,
      buttonName: "בדרך",
      backgroundButttonColor: "white",
      currentPlace: null,
      places: [],
      startLocation: null,
      endLocation: null,
      imageUrl: "",
      showPosMarker: false,
      showButtonInfoScreen: false,
      iconImage: {
        url: require("../../static/img/circle.png"),
      },
      watchPositionId: null,
      position: { lat: null, lng: null },
      showCurrentPositionButton: true,
      myCurrentPosition: "",
      myMapStyle: {
        featureType: "poi",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      firstQuestion: 1,
      showPointInformation: false,
      secondsToTime: "00:00:00",
      gameSecondToTime: "",
      totalSeconds: 0,
      startTime: "",
      endTime: "",
      showLastDialog: false,
      key: "",
      questiomMultipleChoices: true,
      rowPhotoMissingWord: true,
      dialogWrongAnswer: false,
      dialogCorrectAnswer: false,
      loading: false,
      src: "",
      timeNow: "",
      questionNumber: -1,
      errorNumber: 0,
      pointNum: this.$parent.pointNum,
      // currentPointData: this.$parent.currentPointData,
      pointNumForEvolution: 1,
      letter: "",
      allLetters: "",
      gameTimeInSecond: "",
      userKey: "",
      translationMissingWord: "Mot manquant sur l'image",
      translation: "",

      activeClass: "activePoint",
      notActive: "smallPoint",
      activeClassPoint: "activeClassPoint",
      notActivePoint: "numbersInCercle",
      slide: 0,
      sliding: null,
    };
  },
  mounted() {
    this.currentPointData = JSON.parse(localStorage.getItem("currentPointData"))
    console.log("this.currentPointData", this.currentPointData)
    this.timerDisplayText = "0" + this.timePerPoint + ":00";
    this.$nextTick(() => {
      if (this.$refs.gmap) {
        // La plupart des librairies Google Maps pour Vue 3 utilisent $mapPromise
        this.$refs.gmap.$mapPromise.then((map) => {
          console.log("✅ Carte récupérée avec succès !");
          this.mapObject = map;
        });
      }
    });
    if (this.$parent.showLastDialog != true) {
      this.startFiveSecCountDown();
      setTimeout(() => {
        this.countSeconds();
        if (localStorage.getItem("startTime")) {
          this.startTime = localStorage.getItem("startTime");
        } else {
          this.startTime = Date.now();
        }
      }, 6000);
    }
    // if (localStorage.getItem("pointNumber")) {
    //   this.pointNum = parseInt(localStorage.getItem("pointNumber"));
    // }
    this.showCurrentPosition();
    this.checkNoGoogleRoute();
    // if (this.gameParameters) {
    //   console.log("this.gameParameters exist ok");
    // } else {
    //   console.log("bug");
    //   this.reopenGame();
    // }
    this.userKey = localStorage.getItem("userKey");
    history.pushState(null, null, location.href);
    window.onpopstate = function () {
      history.go(1);
    };
    setTimeout(() => {
      this.addMarker();
    }, 1000);
  },
  watch: {
    timerDisplayText(val) {
      // Push timer into parent's center bottom-bar circle
      if (this.$parent) this.$parent.countdownTimer = val;
    },
  },

  computed: {
    // google: gmapApi,

    withVideo() {
      if (localStorage.getItem("withVideo")) {
        return localStorage.getItem("withVideo");
      } else {
        localStorage.setItem(
          "withVideo",
          this.points[this.pointNum + 1].withVideo
        );
        return this.points[this.pointNum + 1].withVideo;
      }
    },
    videoId() {
      if (localStorage.getItem("videoUrl")) {
        return localStorage.getItem("videoUrl");
      } else {
        localStorage.setItem(
          "videoUrl",
          this.points[this.pointNum + 1].videoUrl
        );
        return this.points[this.pointNum + 1].videoUrl;
      }
    },
    timePerPoint() {
      // console.log("this.points[this.pointNum].timePerPoint", this.points[this.pointNum].timePerPoint)
      // localStorage.setItem(
      //   "timePerPoint",
      //   this.points[this.pointNum].timePerPoint);
      // if (localStorage.getItem("timePerPoint")) {
      //   return localStorage.getItem("timePerPoint");
      // } else {

      //   return this.points[this.pointNum].timePerPoint;
      // }
      // 1. Vérifier si points existe et contient le point actuel
      if (this.currentPointData) {
        // On retourne une valeur par défaut (ex: 5 minutes) en attendant le chargement
        return this.currentPointData.timePerPoint || 5;
      } else {
        return 5
      }

      //const value = this.points[this.pointNum].timePerPoint;

      // 2. On retourne la valeur proprement
      //return value !== undefined ? value : 5;

    },
    twoMarkersArray() {
      console.log("this.pointNum", this.pointNum)
      if (this.pointNum == 0) {
        var oneMarkerArrray = [
          {
            lat: this.markers[this.pointNum].position.lat,
            lng: this.markers[this.pointNum].position.lng,
          },
        ];
        return oneMarkerArrray;
      } else {
        var twoMarkersArray = [
          {
            lat: Number(this.markers[this.pointNum - 1].position.lat),
            lng: Number(this.markers[this.pointNum - 1].position.lng),
          },
          {
            lat: Number(this.markers[this.pointNum].position.lat),
            lng: Number(this.markers[this.pointNum].position.lng),
          },
        ];
        return twoMarkersArray;
      }
    },
    // centerMap() {
    //   var centeredMap;
    //   if (this.pointNum == 0) {
    //     centeredMap = {
    //       lat: Number(this.markers[this.pointNum].position.lat),
    //       lng: Number(this.markers[this.pointNum].position.lng),
    //     };
    //   } else {
    //     centeredMap = {
    //       lat:
    //         (Number(this.markers[this.pointNum - 1].position.lat) +
    //           Number(this.markers[this.pointNum].position.lat)) /
    //         2,
    //       lng:
    //         (Number(this.markers[this.pointNum - 1].position.lng) +
    //           Number(this.markers[this.pointNum].position.lng)) /
    //         2,
    //     };
    //   }
    //   return centeredMap;
    // },
    centerMap() {
      // Sécurité CRUCIALE pour le refresh
      const p = this.points && this.pointsArrayOrder
        ? Object.values(this.points)[this.pointsArrayOrder[this.pointNum] - 1]
        : null;

      if (p && p.location && p.location.lat && p.location.lng) {
        return {
          lat: Number(p.location.lat),
          lng: Number(p.location.lng)
        };
      }
      // Coordonnées par défaut en attendant le chargement
      return { lat: 32.657, lng: 35.417 };
    },
    variableBackgroundColor() {
      return {
        "--buttonColor": this.backgroundButttonColor,
      };
    },
    newInformationPointString() {
      return this.points[
        this.pointsArrayOrder[this.pointNum]
      ].pointInformation.replaceAll("\n", "\n");
    },
    audioSrc() {
      if (
        Object.values(this.points)[this.pointsArrayOrder[this.pointNum] - 1]
          .audioUrl
      ) {
        return Object.values(this.points)[
          this.pointsArrayOrder[this.pointNum] - 1
        ].audioUrl;
      } else {
        return null;
      }
    },
    markers() {
      var markers;
      if (localStorage.getItem("markers")) {
        markers = JSON.parse(localStorage.getItem("markers"));
        // console.log("markers", markers);
      } else {
        markers = this.$store.getters.markers;
        // console.log("markers", markers);
      }
      // var markers = this.$store.getters.markers;
      var markersArray = [];
      markers.forEach((marker) => {
        if (marker != null) {
          markersArray.push({ position: { lat: marker.lat, lng: marker.lng } });
        }
      });
      console.log("markersArray", markersArray);

      return markersArray;
    },
    // wayPoints() {
    //   var wayPoints;
    //   if (localStorage.getItem("wayPoints")) {
    //     wayPoints = JSON.parse(localStorage.getItem("wayPoints"));
    //     // console.log("wayPoints", wayPoints);
    //   } else {
    //     wayPoints = this.$store.getters.wayPoints;
    //     // console.log("wayPoints", wayPoints);
    //   }
    //   var wayPointsArray = [];
    //   wayPoints.forEach((wayPoint) => {
    //     if (wayPoint != null) {
    //       wayPointsArray.push(wayPoint);
    //     }
    //   });
    //   // console.log("wayPointsArray", wayPointsArray);
    //   return wayPointsArray;
    // },
    // markers() {
    //   let markers;
    //   const storedMarkers = localStorage.getItem("markers");

    //   if (storedMarkers) {
    //     try {
    //       markers = JSON.parse(storedMarkers);
    //     } catch (error) {
    //       console.error(
    //         "Erreur lors du parsing des markers depuis localStorage :",
    //         error
    //       );
    //       markers = []; // Valeur par défaut si le parsing échoue
    //     }
    //   } else {
    //     markers = this.$store.getters.markers || [];
    //   }

    //   const markersArray = [];
    //   markers.forEach((marker) => {
    //     if (marker != null) {
    //       markersArray.push({ position: { lat: marker.lat, lng: marker.lng } });
    //     }
    //   });

    //   return markersArray;
    // },
    wayPoints() {
      let wayPoints;
      const storedWayPoints = localStorage.getItem("wayPoints");

      if (storedWayPoints) {
        try {
          wayPoints = JSON.parse(storedWayPoints);
        } catch (error) {
          console.error(
            "Erreur lors du parsing des wayPoints depuis localStorage :",
            error
          );
          wayPoints = []; // Valeur par défaut si le parsing échoue
        }
      } else {
        wayPoints = this.$store.getters.wayPoints || [];
      }

      const wayPointsArray = [];
      wayPoints.forEach((wayPoint) => {
        if (wayPoint != null) {
          wayPointsArray.push(wayPoint);
        }
      });

      return wayPointsArray;
    },

    lang() {
      // console.log("this.$store.getters.lang", this.$store.getters.lang);
      return this.translate(this.$store.getters.lang);
    },

    gameParameters() {
      return this.$store.getters.gameParameters;
    },
    pointsArrayOrder() {
      if (localStorage.getItem("pointsArrayOrder")) {
        return JSON.parse(localStorage.getItem("pointsArrayOrder"));
      } else {
        return this.$store.getters.pointsArrayOrder;
      }
    },
    // points() {
    //   return this.$store.getters.points;
    // },
  },

  methods: {
    saveMap(map) {
      console.log("Carte chargée dans DynamicMap !");
      this.mapObject = map;
    },
    logDirections() {
      console.log("Travel Mode:", this.travelMode);
      console.log("Origin:", this.startLocation);
      console.log("Destination:", this.endLocation);
      console.log("Waypoints:", this.wayPoints[this.pointNum]);
    },
    openWaze() {
      const url =
        "https://ul.waze.com/ul?ll=32.65695440%2C35.41763663&navigate=yes&utm_campaign=default&utm_source=waze_website&utm_medium=lm_share_location";
      window.open(url, "_blank");
      this.showOpenWazeAlert = false;
    },
    showSentenceAboveMap() {
      this.sentenceShownAboveMap = "";
      var arrayOfLetters = "";
      arrayOfLetters = JSON.stringify(this.sentenceAboveMap).split("");
      console.log("arrayOfLetters", arrayOfLetters);
      let index = 0;
      var audio = new Audio(this.typingSound);
      audio.play();
      this.loopTextAboveMap = setInterval(() => {
        if (this.sentenceShownAboveMap.length < arrayOfLetters.length - 2) {
          if (arrayOfLetters[index] != '"') {
            this.sentenceShownAboveMap =
              this.sentenceShownAboveMap + arrayOfLetters[index];
          }
          index++;
        } else {
          arrayOfLetters = "";
          this.sentenceAboveMap == "";
          index = 0;
          clearInterval(this.loopTextAboveMap);
          audio.pause();
        }
      }, 150);
    },
    flipToBuzzer() {
      this.showBuzzer = true;
      setTimeout(() => {
        if (document.getElementById("buttonBuzzer").hasAttribute("disabled")) {
          console.log("hasAttribute");
          document
            .getElementById("buttonBuzzer")
            .removeAttribute("disabled", "");
        } else {
          console.log("Does not hasAttribute");
        }
      }, 10);
      clearInterval(this.countDown);
      // I RESET THE TIMEOVER MESSAGE AND THEN ONLY STOP THE LOOP
      this.showMessageTimeFinished = false;
      clearInterval(this.timeFinishedLoop);
      clearInterval(this.loopTextAboveMap);
      this.sentenceShownAboveMap = "";
      this.sentenceAboveMap = "";
      this.sentenceAboveMap = this.translation.clickTheBuzzer;
      this.showSentenceAboveMap();
      var audio = new Audio(this.buzzerFlip);
      audio.play();
    },
    buzzerClicked() {
      var audio = new Audio(this.buzzerClickSound);
      audio.play();
      clearInterval(this.loopTextAboveMap);
      clearInterval(this.countDown);
      this.sentenceShownAboveMap = "";
      this.sentenceAboveMap = "";
      setTimeout(() => {
        clearInterval(this.countDown);
        document.getElementById("buttonBuzzer").setAttribute("disabled", "");
        console.log("this.countDounTimeInSeconds", this.countDounTimeInSeconds);
        if (this.countDounTimeInSeconds > 1) {
          this.addScorePoints();
        } else {
          //this.showVideo = true;
          // localStorage.setItem("showVideo", this.showVideo);
          this.reachedThePoint = false;
          // document.getElementById("g-contrast").classList.add("hide");
          this.showBuzzer = false;
          //  this.showExplosion = false;
          this.countDounTimeInSeconds = "";
          this.showTimerBackground = false;
          localStorage.removeItem("startTimeCountDown");
          this.goToNextStep();
        }
      }, 1000);
    },
    startFiveSecCountDown() {
      this.showFiveSecCountDown = true;
      this.runCheckPosition();
      var seconds = 6;
      var countFiveSec = setInterval(() => {
        if (seconds < 1) {
          if (this.$parent.pointNum == 0) {
            //console.log("lang", this.lang);
            this.sentenceAboveMap = this.translation.goToFirstPoint;
          } else {
            this.sentenceAboveMap = this.translation.followThePath;
          }
          console.log("this.sentenceAboveMap", this.sentenceAboveMap);
          this.showSentenceAboveMap();

          clearInterval(countFiveSec);
          this.countDownSeconds();
          this.showFiveSecCountDown = false;
          this.soundCountDown = false;
        } else {
          this.soundCountDown = true;
          seconds--;
          const el = document.getElementById("fiveSecCountDown");
          if (el) {
            el.innerHTML = seconds;
          }
          // document.getElementById("fiveSecCountDown").innerHTML = seconds;
        }
      }, 1000);
    },
    countSeconds() {
      setInterval(() => {
        this.timeNow = Date.now();
        this.totalSeconds = Math.floor((this.timeNow - this.startTime) / 1000);
        var pad = function (num, size) {
          return ("000" + num).slice(size * -1);
        },
          time = parseFloat(this.totalSeconds).toFixed(3),
          hours = Math.floor(time / 60 / 60),
          minutes = Math.floor(time / 60) % 60,
          seconds = Math.floor(time - minutes * 60);

        this.secondsToTime =
          pad(hours, 2) + ":" + pad(minutes, 2) + ":" + pad(seconds, 2);
      }, 1000);
    },
    countDownSeconds() {
      this.showFiveSecCountDown = false;
      // console.log("start countDownSeconds");
      if (localStorage.getItem("startTimeCountDown")) {
        this.startTimeCountDown = JSON.parse(
          localStorage.getItem("startTimeCountDown")
        );
      } else {
        this.startTimeCountDown = Date.now();
        localStorage.setItem(
          "startTimeCountDown",
          JSON.stringify(this.startTimeCountDown)
        );
      }

      // this.min = this.timePerPoint;
      this.countDown = setInterval(() => {
        this.countDounTimeInSeconds = Math.floor(
          (this.startTimeCountDown +
            this.timePerPoint * 60 * 1000 -
            Date.now()) /
          1000
        );
        var time = parseFloat(this.countDounTimeInSeconds).toFixed(3);
        var minutes = Math.floor(time / 60) % 60;
        var seconds = Math.floor(time - minutes * 60);
        //****************************ONLY FOR TIME FINISHED */
        if (this.min == 0 && this.countDounTimeInSeconds < 1) {
          // this.backgroundButttonColor = "#3F9583";
          clearInterval(this.countDown);
          this.timerDisplayText = "00:00";
          //document.getElementById("timer").innerHTML = "00:00";
          this.timeFinished();
        }
        if (this.reachedThePoint == true && this.countDounTimeInSeconds > 1) {
          // this.backgroundButttonColor = "#3F9583";
          clearInterval(this.countDown);
        }
        if (seconds > 9) {
          // document.getElementById("timer").innerHTML =
          this.timerDisplayText =

            "0" + minutes + ":" + seconds;
        } else {
          // document.getElementById("timer").innerHTML =
          this.timerDisplayText =
            "0" + minutes + ":" + "0" + seconds;
        }
      }, 1000);
    },
    timeFinished() {
      // document.getElementById("timer").innerHTML = "00:00";
      this.timerDisplayText = "00:00";
      this.sentenceAboveMap = this.translation.timeFinished;
      console.log("this.sentenceAboveMap", this.sentenceAboveMap);

      this.showSentenceAboveMap();
      this.timeFinishedLoop = setInterval(() => {
        this.showMessageTimeFinished = !this.showMessageTimeFinished;
        // document.getElementById("timer").innerHTML = "00:00";
        this.timerDisplayText = "00:00";

      }, 5000);
    },
    goToNextStep() {
      this.$parent.showCorrectAnswerIcon = true;
      var audioCorrectAnswerSound = new Audio(this.correctAnswerSound);
      audioCorrectAnswerSound.play();
      this.$parent.checkElementPicked();
      localStorage.setItem("errorNumber", this.$parent.errorNumber);
      localStorage.setItem("showMainScreen", false);

      setTimeout(() => {
        this.$parent.showCorrectAnswerIcon = false;
        this.$parent.afterNavigationComplete();
      }, 3000);
    },
    addScorePoints() {
      // var totalPoints = this.countDounTimeInSeconds * 60 + this.sec;
      var pointIndex = 0;
      // var totalPoints = this.countDounTimeInSeconds;
      //***************************************** */
      var totalPoints = parseFloat(this.countDounTimeInSeconds).toFixed(3);
      var minutes = Math.floor(totalPoints / 60) % 60;
      var seconds = Math.floor(totalPoints - minutes * 60);
      /********************************************************** countTimeToZero + addScorePoints*/
      var audio = new Audio(this.pointsScoreCoins);
      audio.play();
      var countTimeToZero = setInterval(() => {
        seconds--;
        //this.showExplosion = true;
        this.pointsScore++;
        pointIndex++;
        if (Number.isInteger(pointIndex / 3)) {
          // console.log("pointIndex", pointIndex);
          this.$parent.errorNumber = this.$parent.errorNumber + 1;
        }
        if (minutes > 0 && seconds == 0) {
          if (seconds > 9) {
            //  document.getElementById("timer").innerHTML =
            this.timerDisplayText =
              "0" + minutes + ":" + seconds;
          } else {
            this.timerDisplayText =
              "0" + minutes + ":" + "0" + seconds;
          }
          minutes--;
          seconds = 60;
        } else {
          // if (minutes == 0) {
          if (minutes == 0 && seconds == 0) {
            //  document.getElementById("timer").innerHTML = "00:00";
            this.timerDisplayText = "00:00";
            audio.pause();
            audio.currentTime = 0;
            setTimeout(() => {
              //  this.showExplosion = false;
              this.countDounTimeInSeconds = "";
              this.reachedThePoint = false;
              this.showTimerBackground = false;
              this.$parent.showStarUp(Math.ceil(pointIndex / 3));

              setTimeout(() => {
                // this.showVideo = true;
                //  document.getElementById("g-contrast").classList.add("hide");
                //  localStorage.setItem("showVideo", this.showVideo);
                this.showBuzzer = false;
                //  audio.pause();
                // audio.currentTime = 0;
                localStorage.setItem("pointsScore", this.pointsScore);
              }, 3000);
              localStorage.removeItem("startTimeCountDown");
              // var audio = new Audio(this.buzzerClickSound);
              // audio.play();
              this.goToNextStep();
            }, 1000);
            this.reachedThePoint = false;
            clearInterval(countTimeToZero);
          } else {
            if (seconds > 9) {
              //  document.getElementById("timer").innerHTML =
              this.timerDisplayText =
                "0" + minutes + ":" + seconds;
            } else {
              //  document.getElementById("timer").innerHTML =
              this.timerDisplayText =
                "0" + minutes + ":" + "0" + seconds;
            }
          }
          // }
        }
      }, 20);
    },
    playing() {
      console.log("o/ we are watching!!!");
    },
    showMapTrue() {
      this.showMap = true;
    },
    // checkNoGoogleRoute() {
    //   var noGoogleRouteArray = [];
    //   this.points.forEach((point) => {
    //     if (point.noGoogleRoute == true) {
    //       noGoogleRouteArray.push(true);
    //     } else {
    //       noGoogleRouteArray.push(false);
    //     }
    //   });

    //   this.noGoogleRouteArray = noGoogleRouteArray;
    //   console.log("this.noGoogleRouteArray", this.noGoogleRouteArray);
    // },
    checkNoGoogleRoute() {
      if (!this.points || !Array.isArray(this.points)) return;

      this.points.forEach((point) => {
        // AJOUTE CETTE PROTECTION
        if (point && point.noGoogleRoute !== undefined) {
          // ta logique actuelle...
        }
      });
    },
    reopenGame() {
      if (localStorage.getItem("navigationName")) {
        console.log("[reopenGame] ");
        if (localStorage.getItem("pointNum")) {
          this.$router.push("/" + localStorage.getItem("navigationName"));
          location.reload();
        } else {
          this.$router.push("/" + localStorage.getItem("navigationName"));
          localStorage.clear();
          console.log("[reopenGame] NO POINTNUM");
          location.reload();
        }
      } else {
        console.log("[reopenGame] NO navigationName");
        localStorage.clear();
        this.$router.push("/");
        location.reload();
      }
    },
    runCheckPosition() {
      var checkPosition = setInterval(() => {
        let markerLat = this.markers[this.pointNum].position.lat;
        let markerLng = this.markers[this.pointNum].position.lng;
        // console.log("[checkPosition] B4 pos verrification");
        if (
          markerLat > this.myCurrentPosition.lat - this.rangeInPosition &&
          markerLat < this.myCurrentPosition.lat + this.rangeInPosition &&
          markerLng > this.myCurrentPosition.lng - this.rangeInPosition &&
          markerLng < this.myCurrentPosition.lng + this.rangeInPosition
        ) {
          // console.log("[checkPosition] in the range");

          this.backgroundButttonColor = "white";
          this.buttonName = "הגענו!";
          this.showMessageTimeFinished = false;
          clearInterval(this.timeFinishedLoop);
          this.verifyPosition();
          clearInterval(checkPosition);
        } else {
          if (
            markerLat > this.myCurrentPosition.lat - 0.001 &&
            markerLat < this.myCurrentPosition.lat + 0.001 &&
            markerLng > this.myCurrentPosition.lng - 0.001 &&
            markerLng < this.myCurrentPosition.lng + 0.001
          ) {
            // console.log("[checkPosition] ALMOST in the range");

            this.backgroundButttonColor = "white";
            this.gettingClosed = true;
            this.buttonName = "מתקרבים!";
            this.reachedThePoint = false;
          } else {
            // console.log(
            //   "[checkPosition] NOT in the range markerLat markerLng",
            //   markerLng,
            //   markerLat
            // );

            this.backgroundButttonColor = "white";
            this.buttonName = "בדרך";
            this.reachedThePoint = false;
          }
        }
      }, 3000);
    },

    verifyPosition() {
      let index = 0;
      this.showVerifyingPosition = true;
      var checkPosition = setInterval(() => {
        let markerLat = this.markers[this.pointNum].position.lat;
        let markerLng = this.markers[this.pointNum].position.lng;
        if (
          markerLat > this.myCurrentPosition.lat - this.rangeInPosition &&
          markerLat < this.myCurrentPosition.lat + this.rangeInPosition &&
          markerLng > this.myCurrentPosition.lng - this.rangeInPosition &&
          markerLng < this.myCurrentPosition.lng + this.rangeInPosition
        ) {
          this.backgroundButttonColor = "white";
          this.buttonName = "הגענו!";
          index++;
          if (index > 3) {
            // this.reachedThePoint = true;
            this.flipToBuzzer();
            // this.showBuzzer = true;
            clearInterval(this.timeFinishedLoop);

            this.timeFinishedLoop = "";
            clearInterval(checkPosition);
            this.showVerifyingPosition = false;
          }
          //
        } else {
          clearInterval(checkPosition);
          this.backgroundButttonColor = "white";
          this.showVerifyingPosition = false;
          this.runCheckPosition();
        }
      }, 1000);
    },

    setPlace(place) {
      this.currentPlace = place;
    },
    addMarker() {
      if (this.pointNum == 0) {
        const marker1 = {
          lat: this.markers[0].position.lat,
          lng: this.markers[0].position.lng,
        };
        const marker2 = {
          lat: this.markers[0].position.lat,
          lng: this.markers[0].position.lng,
        };
        console.log("marker1 - marker2", marker1, marker2);
        this.startLocation = marker1;
        this.endLocation = marker2;
        console.log(
          "startLocation - endLocation",
          this.startLocation,
          this.endLocation
        );
      } else {
        const marker1 = {
          lat: this.markers[this.pointNum - 1].position.lat,
          lng: this.markers[this.pointNum - 1].position.lng,
        };
        const marker2 = {
          lat: this.markers[this.pointNum].position.lat,
          lng: this.markers[this.pointNum].position.lng,
        };
        this.startLocation = marker1;
        this.endLocation = marker2;
        console.log("marker1 - marker2 NOT FIRST POINT", marker1, marker2);
      }
    },
    showCurrentPosition() {
      if (navigator.geolocation) {
        console.log("navigator.geolocation OK");
        this.showCurrentPositionButton = false;
        this.watchPositionId = navigator.geolocation.watchPosition(
          (position) => {
            let pos = {
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            };
            // console.log("position", position);
            this.myCurrentPosition = pos;
            // console.log("this.myCurrentPosition", this.myCurrentPosition);
            this.showPosMarker = true;
          }
          // () => {
          //   handleLocationError(true, infoWindow, map.getCenter());
          // },
          // { enableHighAccuracy: true }
        );
      } else {
        // Browser doesn't support Geolocation
        alert("Browser doesn't support Geolocation");
        // handleLocationError(false, infoWindow, map.getCenter());
      }
    },

    translate(lang) {
      switch (lang) {
        case "fr":
          this.translationMissingWord = "Missing word on the picture";
          this.translation = {
            allow: "OK",

            showOpenWazeAlert:
              "En appuyant sur OK, Waze va s’ouvrir et activera le GPS de votre téléphone. Cela permettra d’améliorer la précision de votre position dans l’application.",
            timeFinished: "Le temps s'est écoulé",
            getPrecisePosition: "Position précise!",
            goToFirstPoint: "Rendez-vous au premier point",
            followThePath: "Suivez le parcours sur la carte",
            clickTheBuzzer: "Appuyez sur le buzzer!",
            back: "Fermer",
            mistakes: "Mistakes",
            runningTime: "Elapsed time",
            map: "Map",
            pointNumber: "On the map, find the nº",
            goThere: "Go there, and find this inscription ",
            didYouKnow: "Did you know?",
            goToQuestions: "Go to questions!",
            wellDone: "Well done!",
            correctAnswer: "The answer is correct!",
            continue: "Let’s continue…",
            wrongAnswer: "That's not the correct answer.",
            tryAgain: "Let's try again!",
            visitOf: "We hope you enjoyed your visit of",
            yourResults: "Your results are:",
            errorNumber: "Mistakes:",
            totalTime: "Total time:",
            checkLocation: "הגעתי !",
            evolution: "התקדמות",
            timeOver:
              "Votre temps s'est écoulé, rendez-vous au point indiqué sur la carte",
            locationVerification: "בדיקת מיקום",
          };

          // code block
          break;
        case "he":
          this.translationMissingWord = "מילה חסרה בתמונה";
          this.translation = {
            allow: "אישור",
            showOpenWazeAlert:
              "בלחיצה על 'אישור', אפליקציית Waze תיפתח וה-GPS של הטלפון יופעל. זה ישפר את הדיוק של המיקום שלך באפליקציה.",

            timeFinished: "הזמן תם",
            getPrecisePosition: "לדייק מיקום",

            goToFirstPoint: "גשו לנקודה הראשונה",
            followThePath: "עקבו אחר המסלול על המפה",
            clickTheBuzzer: "לחצו על הבאזר!",
            back: "סגור",
            mistakes: "טעויות",
            runningTime: "זמן שחלף",
            map: "מפה",
            pointNumber: "במפה, מצאו את מספר",
            goThere: "גשו לשם ומצאו את הכתובת הבאה",
            didYouKnow: "האם ידעת?",
            goToQuestions: "גשו לשאלות!",
            wellDone: "כל הכבוד!",
            correctAnswer: "התשובה נכונה!",
            continue: "ממשיכים…",
            wrongAnswer: "זו לא התשובה הנכונה.",
            tryAgain: "בואו ננסה שוב!",
            visitOf: "אנו מקווים שנהניתם מהביקור ב",
            yourResults: "התוצאות שלך:",
            errorNumber: "טעויות:",
            totalTime: "זמן כולל:",
            checkLocation: "הגעתי!",
            evolution: "התקדמות",
            timeOver: "הזמן שלכם תם, גשו לנקודה המסומנת על המפה",
            locationVerification: "בדיקת מיקום",
          };

          // code block
          break;
        default:
        // code block
      }
    },

    showResults() {
      // console.log("showResults");
      // localStorage.clear();
      this.$router.push("/resultsByPoints");
      // this.$store.dispatch("getResults", this.gameParameters.navigationName);
    },
    checkLocation() {
      console.log(
        "this.markers[this.pointNum].position.lat",
        this.markers[this.pointNum].position.lat
      );
      this.dialogCorrectAnswer = true;
    },
  },
};
</script>

<style scoped>
.allowButton {
  background: #0090e3;
  color: white;
  border-radius: 50px;
  padding: 10px 24px;
  font-weight: 700;
  font-family: VarelaRound, sans-serif;
  border: none;
  box-shadow: 0 4px 0 #0065a3;
}

.precisePosition {
  font-family: VarelaRound, sans-serif;
  color: white;
  font-size: 15px;
  font-weight: 700;
  background: rgba(0, 0, 0, 0.5);
  border: 1px solid rgba(255, 255, 255, 0.3);
  margin: 0 auto;
  border-radius: 50px;
  backdrop-filter: blur(10px);
  padding: 8px 18px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.continueButton {
  width: 200px !important;
  left: 50px;
  top: -32px;
}

.continueButton.active {
  top: -26px !important;
}

.pointInfoDiv {
  color: gray;
  width: 100vw;
  height: 100%;
  background: white;
  min-height: 370px;
  padding: 20px;
  border: 4px solid #51c9b0;
  direction: rtl;
  text-align: right;
}

.hide {
  display: none;
}

.timerBackground {
  position: fixed;
  bottom: 90px;
  z-index: 3;
  background: linear-gradient(135deg, #0065a3, #0090e3);
  height: 88px;
  width: 88px;
  border-radius: 100%;
  border: 3px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.35), 0 0 0 4px rgba(0, 144, 227, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  left: 50%;
  transform: translateX(-50%);
}

.bg-red {
  background: #ff7b7d !important;
  box-shadow: 0 0 0 1px #b6494d inset, 0 0 0 2px rgb(255 255 255 / 15%) inset,
    0 3px 0 0 #b6494d, 0 8px 8px 1px rgb(0 0 0 / 50%) !important;
}

.bg-green {
  background: #99bd39 !important;
  box-shadow: 0 0 0 1px #687f27 inset, 0 0 0 2px rgb(255 255 255 / 15%) inset,
    0 3px 0 0 #687f27, 0 8px 8px 1px rgb(0 0 0 / 50%) !important;
}

.buzzerBottom {
  height: 50px;
  width: 30px;
  background: black;
}

.walkingGif {
  height: 101px;
  bottom: 5px;
  left: 1px;
  position: relative;
  /* border: 2px solid blue; */

  /* -webkit-transform-style: preserve-3d;
  animation: spin 2s linear infinite;
  transform-style: preserve-3d; */
}

@keyframes spin {
  0% {
    transform: rotateY(0deg);
    transform-style: preserve-3d;
  }

  100% {
    transform: rotateY(360deg);
    transform-style: preserve-3d;
  }
}

.buzzerButton {
  position: relative;
  border: 0;
  -webkit-transition: all 80ms linear;
  transition: all 80ms linear;
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: 2px;
  margin-right: 2px;
  background: radial-gradient(circle at 42px 36px, white, red);
  height: 179px;
  width: 180px;
  border-radius: 100px;
  top: -68px;
  left: 2px;
}

.buzzerButton:active:focus,
.buzzerButton:focus:hover,
.buzzerButton:focus {
  -moz-outline-style: none;
  outline-style: none;
  outline: medium none;
}

.buzzerButton:active,
.buzzerButton.active {
  top: -30px;
}

.buzzerButton.btn-primary {
  box-shadow: 0 0 0 1px #447c70 inset, 0 0 0 2px rgba(255, 255, 255, 0.15) inset,
    0 40px 8px 1px rgba(0, 0, 0, 0.5);
  background-color: #447c70;
}

.buzzerButton.btn-primary:active,
.buzzerButton.btn-primary.active {
  box-shadow: 0 0 0 1px #447c70 inset, 0 0 0 1px rgba(255, 255, 255, 0.15) inset,
    0 3px 0px 0px rgba(0, 0, 0, 0.3), 0 60px 8px 1px rgba(0, 0, 0, 0.5);
  background-color: #447c70;
}

.btn3d {
  position: relative;
  top: -6px;
  border: 0;
  transition: all 40ms linear;
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: 2px;
  margin-right: 2px;
}

.btn3d:active:focus,
.btn3d:focus:hover,
.btn3d:focus {
  -moz-outline-style: none;
  outline: medium none;
}

.btn3d:active,
.btn3d.active {
  top: 2px;
}

.btn3d.btn-primary {
  /* box-shadow: 0 0 0 1px #417fbd inset, 0 0 0 2px rgba(255, 255, 255, 0.15) inset,
    0 8px 0 0 #4d5bbe, 0 8px 8px 1px rgba(0, 0, 0, 0.5); */
  box-shadow: 0 0 0 1px #447c70 inset, 0 0 0 2px rgb(255 255 255 / 15%) inset,
    0 8px 0 0 #447c70, 0 8px 8px 1px rgb(0 0 0 / 50%);
  /* background-color: #4274d7; */
  background-color: rgb(63, 149, 131);
}

.btn3d.btn-primary:active,
.btn3d.btn-primary.active {
  box-shadow: 0 0 0 1px #447c70 inset, 0 0 0 1px rgba(255, 255, 255, 0.15) inset,
    0 1px 3px 1px rgba(0, 0, 0, 0.3);
  background-color: rgb(63, 149, 131);
}

#buzzer {
  animation-name: appear;
  animation-duration: 0.5s;
}

@keyframes appear {
  0% {
    top: 500px;
  }
}

#buzzer img {
  position: absolute;
  bottom: calc(50vh - 180px);
  left: calc(50vw - 180px);
  border-radius: 230px;
  -webkit-animation: scaling 0.7s infinite alternate;
}

@-webkit-keyframes scaling {
  from {
    -webkit-transform: scale(1);
  }

  to {
    -webkit-transform: scale(1.1);
  }
}

#videoDiv {
  margin-bottom: -5px;
}

.fullScreenMessages {
  position: fixed;
  top: 0px;
  left: 0px;
  height: 100vh;
  width: 100vw;
  background: rgba(0, 20, 60, 0.88);
  backdrop-filter: blur(8px);
  z-index: 10;
  color: white;
  text-align: center;
  padding-top: 27vh;
  font-size: 160px;
  font-family: VarelaRound, sans-serif;
  font-weight: 900;
  text-shadow: 0 0 40px rgba(0, 144, 227, 0.8), 0 4px 12px rgba(0, 0, 0, 0.5);
}

.messageOverMap {
  position: absolute;
  display: flex;
  top: 4px;
  left: 0px;
  height: 50vh;
  width: 100vw;
  background: rgba(0, 30, 80, 0.82);
  backdrop-filter: blur(10px);
  z-index: 10;
  color: white;
  text-align: center;
  font-size: 28px;
  font-family: VarelaRound, sans-serif;
  border-radius: 0 0 24px 24px;
  direction: rtl;
  flex-wrap: wrap;
  align-content: center;
  justify-content: center;
  flex-direction: column;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-top: none;
}

#buzzer.messageOverMap {
  background: transparent;
  backdrop-filter: blur(12px);
  padding-top: 8vh;
  border-radius: 16px;
  left: 4px;
  width: calc(100vw - 8px);
}

#timer {
  background: transparent;
  color: white;
  font-size: 22px;
  font-weight: 900;
  font-family: VarelaRound, sans-serif;
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);
  letter-spacing: 1px;
}

.textEncouragement {
  font-family: VarelaRound;
  color: chartreuse;
  position: absolute;
  top: 40vh;
  font-size: 40px;
  /* -webkit-text-stroke: 1px red;  width and color */
  text-align: center;
}

@keyframes blinker {
  40% {
    opacity: 90%;
  }

  50% {
    opacity: 50%;
  }

  60% {
    opacity: 90%;
  }
}

.sentenceAboveMap {
  direction: rtl;
  height: 54px;
  text-align: center;
  font-size: 18px;
  font-weight: 700;
  color: white;
  font-family: VarelaRound, sans-serif;
  /* background: rgba(0, 0, 0, 0.5); */
  backdrop-filter: blur(2px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 50px;
  display: block;
  margin: 0 auto 6px;
  padding: 10px 20px;
  max-width: 90vw;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
}

.buttonStyle {
  left: 15px;
  padding-bottom: 15px;
  position: relative;
  bottom: 28px;
}

.buttonStyleAlmostThere {
  color: white;
  position: relative;
  font-weight: bold;
  font-size: 35px;
  background-color: orangered;
  padding: 10px;
  border-radius: 17px;
  animation: glowing 1300ms infinite;
}

.checkLocationButtonDisabeld {
  font-size: 18px;
  height: 88px;
  width: 88px;
  font-weight: bold;
  font-family: VarelaRound, sans-serif;
  color: rgba(255, 255, 255, 0.35);
  border-radius: 100px;
  background: rgba(255, 255, 255, 0.08);
  border: 2px solid rgba(255, 255, 255, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
}

.checkLocationButton {
  font-size: 18px;
  height: 100px;
  width: 100px;
  font-weight: 800;
  font-family: VarelaRound, sans-serif;
  background: linear-gradient(135deg, #22c55e, #16a34a) !important;
  color: white;
  border-radius: 100px;
  border: 3px solid rgba(255, 255, 255, 0.4);
  box-shadow: 0 0 0 6px rgba(34, 197, 94, 0.25);
  animation: glowing 1300ms infinite;
  display: flex;
  align-items: center;
  justify-content: center;
}

@keyframes glowing {
  0% {
    /* background-color: #2ba805;
    box-shadow: 0 0 5px #2ba805; */
    background-color: var(--buttonColor);
    box-shadow: 0 0 5px var(--buttonColor);
  }

  50% {
    /* background-color: #49e819;
    box-shadow: 0 0 20px #49e819; */
    background-color: var(--buttonColor);
    box-shadow: 0 0 25px var(--buttonColor);
  }

  100% {
    /* background-color: #2ba805;
    box-shadow: 0 0 5px #2ba805; */
    background-color: var(--buttonColor);
    box-shadow: 0 0 5px var(--buttonColor);
  }
}

.toQuestionButton {
  border: 1px solid #999999;
  background-color: #cce3ca !important;
  color: #605e5e;
  font-size: 20px;
  font-weight: bold;
  top: -38px;
  border-radius: 50%;
  height: 100px;
  width: 100px;
  position: relative;
}

.mainButton {
  border-radius: 50px;
  height: 56px;
  color: white !important;
  display: block;
  margin: 0px auto;
  height: 90px !important;
  width: 90px;
  border: solid darkgreen 2px;
}

.currentPosButton {
  position: absolute;
  top: 61px;
  font-size: 19px;
  z-index: 100;
  color: green;
  left: 11px;
  direction: rtl;
  font-family: VarelaRound;
  background: white;
  border: 1px solid green;
  padding: 7px 8px 0px;
  border-radius: 5px;
}

#erreurs {
  font-size: 12px;
  position: absolute;
  top: 27px;
  left: calc(50% - 28px);
}

#evolution {
  font-size: 12px;
  position: absolute;
  top: 27px;
  left: calc(50% - 35px);
}

#runningTime {
  font-size: 12px;
  position: absolute;
  top: 27px;
  left: calc(50% - 13px);
}

#carte {
  font-size: 12px;
  position: absolute;
  top: 27px;
  left: calc(50% - 6px);
}

.center {
  display: block;
  margin: 0px auto;
}

#mapButton {
  width: 30px;
  position: absolute;
  top: 4px;
  right: -10px;
  margin-right: calc(50vw - 155px);
  font-size: 25px;
  color: white;
  /* border: solid 1px black; */
  width: 42px;
  height: 40px;
  padding: 5px;
  /* background: white; */
  z-index: 5;
}

#map {
  position: fixed;
  top: -100vh;
  right: 0;
  height: 100vh;
  width: 100vw;
  z-index: 100;
  overflow: hidden;
  transition: all 1s;
}

#map2 {
  right: 0;
  width: 100vw;
  max-width: 600px;

  overflow: hidden;
  /* transition: all 1s; */
  border: solid 4px;
  border-color: var(--buttonColor);
  border-radius: 16px;
  background: transparent;
  /* animation: hueRotate 10s infinite linear; */
}

#timeFinishedElement {
  border-radius: 16px;
}

.showMap {
  position: fixed;
  top: 0 !important;
  right: 0;
  height: 100vh;
  width: 100vw;
  z-index: 100;
  overflow: hidden !important;
  transition: all 1s;
}

#imgUrl {
  display: block;
  margin: 0 auto;
}

.errorsTimeMap {
  background: rgba(255, 255, 255, 1);
  border: none;
  font-size: 20px;
  padding-top: 5px;
}

.errorsTimeMap>svg {
  position: relative;
  bottom: 3px;
}

.pointNumber {
  margin: 0 auto;
  border: #d41a1b solid 2px;
  border-radius: 100px;
  height: 55px;
  width: 55px;
  font-size: 36px;
  padding-right: 1px;
  padding-top: 4px;
}

.rtl {
  direction: rtl;
}

.verticalAlign {
  margin: 0;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  width: 80%;
}

.myModal {
  min-height: 200px;
  overflow: auto;
  width: 300px;
  border-radius: 10px;
  display: block;
  margin: 0px auto;
  margin-top: calc(50vh - 170px);
  color: white;
}

.modalInformationPoint {
  box-shadow: none;
  border: solid rgb(9, 133, 235) 3px;
  margin-top: 1vh;
  width: 98vw;
  font-size: 22px;
  height: 98vh;
  overflow: auto;
  background: rgb(20, 186, 236);
  color: white;
}

.red {
  background-color: #d41a1b;
  border: solid white 2px;
}

.green {
  background-color: #0aa78d;
  border: 4px #eef307 solid;
}

.over {
  position: absolute;
  top: 0px;
  font-size: 18px;
  left: 0px;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.6);
  position: fixed;
  z-index: 3;
}

.colorBtn {
  border-radius: 36px;
  min-height: 56px;
  color: white;
}

.fullWidth {
  width: 80%;
  display: block;
  margin: 0px auto;
  border-radius: 50px;
}

.question {
  text-align: center;
  font-family: "Assistant", sans-serif;
  font-weight: 400;
  font-size: 22px;
  color: black;
}

.btnAnswer {
  margin: 0 auto;
  width: 320px;
  height: 60px;
  border-radius: 35px;
  font-size: 20px;
  color: white;
  background: rgb(64, 150, 83) !important;
}

.title {
  font-size: 25px;
  text-align: right;
  color: black;
}

.userName {
  font-size: 18px;
  text-align: left;
  color: black;
}

.time {
  letter-spacing: 0.05em;
  font-size: 24px;
  font-family: "Cabin", sans-serif;
  text-align: center;
  color: rgb(14, 15, 14, 0.8);
}

.startTime {
  letter-spacing: 0.05em;
  font-size: 40px;
  padding: 5px 0;
  font-family: "Inconsolata", monospace;
  color: #ffffff;
  text-align: center;
  position: relative;
  left: 50%;
  margin-top: 50px;
  top: -24px;
  transform: translate(-50%, -50%);
  color: #daf6ff;
}

.hebrewText {
  text-align: right;
  font-size: 15px;
  padding-right: 5px;
  color: black;
}

.fadeIn {
  -webkit-animation: fadein 1s;
  /* Safari, Chrome and Opera > 12.1 */
  -moz-animation: fadein 1s;
  /* Firefox < 16 */
  -ms-animation: fadein 1s;
  /* Internet Explorer */
  -o-animation: fadein 1s;
  /* Opera < 12.1 */
  animation: fadein 1s;
}

.fadeInVideo {
  -webkit-animation: fadein 5s;
  /* Safari, Chrome and Opera > 12.1 */
  -moz-animation: fadein 5s;
  /* Firefox < 16 */
  -ms-animation: fadein 5s;
  /* Internet Explorer */
  -o-animation: fadein 5s;
  /* Opera < 12.1 */
  animation: fadein 5s;
}

@keyframes fadein {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

/* Firefox < 16 */
@-moz-keyframes fadein {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

/* Safari, Chrome and Opera > 12.1 */
@-webkit-keyframes fadein {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

/* Internet Explorer */
@-ms-keyframes fadein {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

/* Opera < 12.1 */
@-o-keyframes fadein {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@font-face {
  font-family: noot;
  src: url(../../static/fonts/Noot/noot-aj.woff);
}
</style>